<script setup>
import { useI18n } from 'vue-i18n'

defineProps({ events: { type: Array, default: () => [] } })

const { t } = useI18n()

function describe(event) {
  switch (event.kind) {
    case 'delivery_created':
      return event.payload?.broadcast_or_assigned === 'assigned'
        ? t('driver_portal.delivery.event.assigned')
        : t('driver_portal.delivery.event.created')
    case 'delivery_claimed':
      return t('driver_portal.delivery.event.claimed')
    case 'delivery_in_progress':
      return t('driver_portal.delivery.event.in_progress')
    case 'delivery_completed':
      return t('driver_portal.delivery.event.completed')
    case 'delivery_cancelled':
      return event.payload?.reason
        ? `${t('driver_portal.delivery.event.cancelled')}: ${event.payload.reason}`
        : t('driver_portal.delivery.event.cancelled')
    case 'delivery_reassigned':
      return t('driver_portal.delivery.event.reassigned')
    case 'delivery_updated':
      return describeChanges(event.payload?.changes || {})
    default:
      return event.kind
  }
}

function describeChanges(changes) {
  const parts = []
  if (changes.address)       parts.push(`address: ${changes.address[0]} → ${changes.address[1]}`)
  if (changes.scheduled_for) parts.push(t('driver_portal.delivery.event.time_changed'))
  if (changes.notes)         parts.push(t('driver_portal.delivery.event.note_updated'))
  return parts.length
    ? `${t('driver_portal.delivery.event.updated')}: ${parts.join(', ')}`
    : t('driver_portal.delivery.event.updated')
}

function formatTs(raw) {
  if (!raw) return ''
  return new Date(raw).toLocaleString()
}
</script>

<template>
  <section class="events">
    <h3 class="events__heading">{{ t('driver_portal.delivery.event.history') }}</h3>
    <ul class="events__list">
      <li v-for="e in events" :key="e.id" class="events__item">
        <span class="events__ts">{{ formatTs(e.created_at) }}</span>
        <span class="events__desc">{{ describe(e) }}</span>
      </li>
      <li v-if="events.length === 0" class="events__empty">
        {{ t('driver_portal.delivery.event.none') }}
      </li>
    </ul>
  </section>
</template>

<style scoped>
.events { margin-top: 1.5rem; }
.events__heading {
  font-size: 0.8125rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--muted);
  margin: 0 0 0.5rem;
}
.events__list { list-style: none; padding: 0; margin: 0; }
.events__item {
  display: flex;
  gap: 0.75rem;
  padding: 0.4rem 0;
  border-bottom: 1px solid var(--line);
  font-size: 0.875rem;
}
.events__item:last-child { border-bottom: 0; }
.events__ts  { color: var(--muted); white-space: nowrap; flex-shrink: 0; }
.events__desc { color: var(--ink); }
.events__empty { color: var(--muted); font-size: 0.875rem; padding: 0.4rem 0; }
</style>
